var exports = {
  "k": "x127c5a35--3cd629--container",
};

module.exports = exports;
